import {Injectable, signal, WritableSignal} from '@angular/core';
import {CookieConsentModel} from '../../enum/cookie-consent.enum';

@Injectable({
  providedIn: 'root'
})
export class CookieConsentService {

  public cookieConsentSignal: WritableSignal<CookieConsentModel | null> = signal<CookieConsentModel | null>(null);

  public setConsent(value: CookieConsentModel): void {
    this.cookieConsentSignal.set(value);
  }
}
